var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid usa" }, [
      _c("div", { staticClass: "niem-tag-line" }, [
        _vm._v("NATIONAL INFORMATION EXCHANGE MODEL")
      ]),
      _c("div", { staticClass: "official" }, [
        _c("img", {
          attrs: {
            alt: "US flag",
            src: require("../assets/images/us-flag.png")
          }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }